module.exports = __webpack_public_path__ + "tovarni2.jpg?b061cf29d9444809da6e941800acd698";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tovarni2.jpg
// module id = 283
// module chunks = 0